<template>
  <div>
    <!-- <div class="row no-gutters justify-content-between align-items-center">
      <div class="col-md-4 customHeading">
        <h3>{{ moduleName }}</h3>
      </div>

      <div class="col-md-2">
        <b-form-group
          label="Start Date"
          label-for="datepicker-1"
          autocomplete="off"
        >
          <b-form-datepicker
            id="datepicker-1"
            v-model="StartDate"
            placeholder="Choose a date"
            local="en"
            @input="getProductionReport()"
            size="sm"
            required
          ></b-form-datepicker>
        </b-form-group>
      </div>
      <div class="col-md-2">
        <b-form-group
          label="End Date"
          label-for="datepicker-2"
          autocomplete="off"
        >
          <b-form-datepicker
            id="datepicker-2"
            v-model="EndDate"
            placeholder="Choose a date"
            local="en"
            @input="getProductionReport()"
            size="sm"
            required
          ></b-form-datepicker>
        </b-form-group>
      </div>
      <div class="col-md-1">
        <b-form-group
          label="Start Time"
          label-for="Start Time"
          autocomplete="off"
        >
          <b-form-select
            v-model="SelectedStartTimeSlot"
            :options="timeSlots"
            value-field="id"
            text-field="timeSlot"
            required
            size="sm"
          >
            <b-form-select-option :value="null" disabled hidden
              >Select Start Time</b-form-select-option
            >
          </b-form-select>
        </b-form-group>
      </div>
      <div class="col-md-1">
        <b-form-group label="End Time" label-for="End Time" autocomplete="off">
          <b-form-select
            v-model="SelectedStartTimeSlot"
            :options="timeSlots"
            value-field="id"
            text-field="timeSlot"
            required
            size="sm"
          >
            <b-form-select-option :value="null" disabled hidden
              >Select End Time</b-form-select-option
            >
          </b-form-select>
        </b-form-group>
      </div>
    </div> -->

    <div class="">
      <div
        class="custom-row custom-options-menu justify-content-between align-items-center"
      >
        <div class="customHeading">
          <nav>
            <div
              class="nav nav-tabs custom-nav-tabs"
              id="nav-tab"
              role="tablist"
            >
              <a
                class="nav-item nav-link custom-nav-link active"
                id="nav-table-tab"
                data-toggle="tab"
                href="#nav-table"
                role="tab"
                aria-controls="nav-table"
                aria-selected="true"
              >
                <span> {{ moduleName }} </span>
              </a>
            </div>
          </nav>
        </div>
        <div class="">
          <div class="custom-icons-group">
            <div class="custom-row w3-center custom-filter-section no-gutters">
              <div
                class="custom-btn"
                data-toggle="tooltip"
                data-placement="top"
                title="Filters"
              >
                <b-form-group
                  label="Start Date"
                  label-for="datepicker-1"
                  autocomplete="off"
                >
                  <b-form-datepicker
                    id="datepicker-1"
                    v-model="StartDate"
                    placeholder="Choose Start Date"
                    local="en"
                    @input="getProductionReport()"
                    size="sm"
                    required
                    :max="EndDate"
                  ></b-form-datepicker>
                </b-form-group>
              </div>

              <div
                class="custom-btn"
                data-toggle="tooltip"
                data-placement="top"
                title="Filters"
              >
                <b-form-group
                  label="End Date"
                  label-for="datepicker-2"
                  autocomplete="off"
                >
                  <b-form-datepicker
                    id="datepicker-2"
                    v-model="EndDate"
                    placeholder="Choose End Date"
                    local="en"
                    @input="getProductionReport()"
                    size="sm"
                    required
                    :min="StartDate"
                  ></b-form-datepicker>
                </b-form-group>
              </div>

              <!---ADD BUTTON-->
              <div class="custom-btn">
                <b-form-group
                  label="Start Time"
                  label-for="Start Time"
                  autocomplete="off"
                >
                  <b-form-select
                    v-model="SelectedStartTimeSlot"
                    :options="timeSlots"
                    value-field="id"
                    text-field="timeSlot"
                    required
                    size="sm"
                    @change="getTimeWiseProductions"
                  >
                    <b-form-select-option :value="null" disabled hidden
                      >Select Start Time</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>
              </div>

              <!-- Separator -->
              <!-- <div class="custom-btn">
                <div class="custom-icon icon">
                  <span style="font-weight: 300; font-size: 15px">|</span>
                </div>
              </div> -->

              <div
                class="custom-btn"
                data-toggle="tooltip"
                data-placement="top"
                title="Filters"
              >
                <b-form-group
                  label="End Time"
                  label-for="End Time"
                  autocomplete="off"
                >
                  <b-form-select
                    v-model="SelectedEndTimeSlot"
                    :options="timeSlots"
                    value-field="id"
                    text-field="timeSlot"
                    required
                    size="sm"
                    @change="GetEndTimeWiseProductions"
                  >
                    <b-form-select-option :value="null" disabled hidden
                      >Select End Time</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="collapse" id="filterSection">
        <div class="card card-body custom-filter-body">
          <div class="custom-filter-wrap">
            <div class="custom-row d-flex justify-content-between">
              

              <div class="custom-filter-column">
                <b-form inline>
                

                  <b-form-group
                    label=""
                    label-for="datepicker-2"
                    autocomplete="off"
                    style="margin-bottom: 0px;"
                  >
                    <b-form-datepicker
                      id="datepicker-2"
                      v-model="FromDate"
                      @input="getWheatReceives()"
                      placeholder="Choose Start Date"
                      local="en"
                    ></b-form-datepicker>
                  </b-form-group>
                </b-form>
              </div>

              <div class="custom-filter-column">
                <b-form inline>
                  
                  <b-form-group
                    label=""
                    style="margin-bottom: 0px;"
                    label-for="datepicker-1"
                    autocomplete="off"
                  >
                    <b-form-datepicker
                      id="datepicker-1"
                      v-model="ToDate"
                      placeholder="Choose End Date"
                      @input="getWheatReceives()"
                      local="en"
                    ></b-form-datepicker>
                  </b-form-group>
                </b-form>
              </div>

              <div class="custom-filter-column">
                <b-form inline>
                 
                  <b-form-select
                    v-model="IsGovt"
                    :options="statusOptions"
                    class="class-dropdown"
                    @change="getWheatReceives()"
                  ></b-form-select>
                </b-form>
              </div>

              <div class="custom-filter-column">
                <b-form inline>
                 
                  <b-form-select
                    v-model="IsNonInventory"
                    :options="inventoryOptions"
                    class="class-dropdown"
                    @change="getWheatReceives()"
                  ></b-form-select>

                
  
                </b-form>
              </div>

              <div class="custom-filter-column">
                <b-form inline>
                  <select
                    class="mb-2 mr-sm-2 mb-sm-0 custom-select-option form-control"
                    v-model="wheatTypeId"
                    @change="getWheatReceives"
                  >
                    <option value="null">Select Wheat Type (All)</option>
                    <option
                      v-for="option in wheatTypes"
                      :key="option.id"
                      :value="option.id"
                    >
                      {{ option.name }}
                    </option>
                  </select>
                </b-form>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>

    <div class="custom-accordion-separator">
      <div class="custom-separator"></div>
    </div>

    <!-- <div class="row">
      <div class="col">
        <hr
          color="#CACACA"
          style="border-top: 2px solid rgb(202, 202, 202); margin-top: 5px;"
        />
      </div>
    </div> -->
    <div>
      <div class="row">
        <div class="col">
          <table
            class="table table-striped table-borderless cutom-table table-striped table-sm"
            style="font-size: 85%;"
          >
            <thead>
              <tr>
                <th role="columnheader">&nbsp;</th>
                <th v-for="weight in weights" :key="weight.id">
                  {{ weight.weight }}
                </th>
                <th role="columnheader">Total</th>
              </tr>
            </thead>
            <tbody >
              <tr
                v-if="productionData == null || productionEntries.length == 0"
              >
                <td colspan="10" class="center-td">No Data</td>
              </tr>

              <tr
                v-else
                v-for="rec in productionEntries"
                :key="rec.flourTypeId"
              >
                <td role="cell" class="report-first-td">
                  {{ rec.flourTypeName }}
                </td>
                <td
                  role="cell"
                  v-for="item in rec.productionDetails"
                  :key="item.flourWeightTypeLinkId"
                >
                  <span v-if="item.noOfSacks > 0 || item.kGs > 0">
                    {{ item.noOfSacks }} &nbsp;Sacks {{ item.kGs }} &nbsp;KGs
                    {{ item.tons }} &nbsp;TONs
                  </span>
                  <span v-else>-</span>
                </td>
                <td>
                  {{ rec.totalKGs }}&nbsp;KGs {{ rec.totalTons }}&nbsp;TONs
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!--PAGINATION START-->
      <div class="container-fluid mb-3">
        <div class="row justify-content-between align-items-center">
          <div class="col-md-2">
            <div class="showPages">
              <select
                class="form-control"
                id="selClass"
                v-model="perPage"
                @change="getProductionReport()"
              >
                <option
                  v-for="option in options"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-md-8 d-flex justify-content-center">
            <div class="overflow-auto">
              <b-pagination
                v-model="page"
                :total-rows="rows"
                :per-page="perPage"
                first-text="First"
                prev-text="Prev"
                next-text="Next"
                last-text="Last"
                @change="getPage"
              ></b-pagination>
            </div>
          </div>

          <div class="col-md-2">
            <input
              class="form-control search-box page-no-search"
              type="text"
              v-bind:placeholder="page"
              aria-label="search"
              v-model.number="pageNumOnSearch"
              style="height:38px"
            />

            <button
              class="search-button btn btn-primary search page-no-search-btn"
              @click="search()"
            >
              GO
            </button>
          </div>
        </div>
      </div>
      <!--/PAGINATION END-->
      <!--SPINNER-->
      <Spinner
        v-if="productionData===null && apiStatus===10"
        message="Loading..."
        size="medium"
        line-fg-color="rgb(222 224 219"
        line-bg-color="rgb(68 66 62)"
      >
      </Spinner>
       <!-- <Spinner
        v-if="productionData===null && apiStatus===10"
        message="Loading..."
        size="medium"
        line-fg-color="rgb(222 224 219"
        line-bg-color="rgb(68 66 62)"
      >
      </Spinner> -->
      <!--/SPINNER-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import config from '../config.js';
import Spinner from "vue-simple-spinner";

export default {
  name: "ProductionReport",
  data() {
    return {
      moduleName: "Production Report",
      isLoading: false,

      StartDate: new Date(),
      EndDate: new Date(),
      productionData: null,
      productionEntries: null,
      weights: null,
      pageNumOnSearch: "",
      filteredText: "",
      rows: 0,
      page: 1,
      options: [
        { text: "Show 2", value: 2 },
        { text: "Show 10", value: 10 },
        { text: "Show 25", value: 25 },
        { text: "Show 50", value: 50 },
        { text: "Show 100", value: 100 },
      ],
      perPage: 25,
      timeSlots: null,
      SelectedStartTimeSlot: null,
      SelectedEndTimeSlot: null,
      apiStatus: 10 // defaultValue
    };
  },

  methods: {
    getPage(page) {
      this.page = page;
      this.getProductionReport();
    },

    getProductionReport() {
      this.isLoading = true;
      this.apiStatus = 10;

      if(this.SelectedEndTimeSlot < this.SelectedStartTimeSlot && this.StartDate===this.EndDate){
        // this.$refs.toaster.showToast("Error", "danger", "Please select correct end time");
        this.$bvToast.toast("Please select correct End Time", {
          title: "Error",
          solid: true,
          variant: 'danger'
        });
      }
      this.productionData = null;
      axios
        .post("/productionreport/getall", {
          UserId: this.$auth.user().id,
          CompanyId: this.$auth.user().companyId,
          PageSize: this.perPage,
          Page: this.page,
          FromDate: this.StartDate,
          ToDate: this.EndDate,
          StartTimeId: this.SelectedStartTimeSlot,
          EndTimeId: this.SelectedEndTimeSlot,
        })
        .then((res) => {
          console.log(res.data);
          if (res.data.status == 1) {
            // console.log(res.data)
            this.productionData = res.data.data;
            this.weights = this.productionData.flourWeights;
            this.productionEntries = this.productionData.records;
            this.rows = res.data.totalRecords;
           


          } else if (res.data.status == 0) {
            this.productionData = null;
          } else if (res.data.status == -1) {
            this.$bvModal.msgBoxOk(res.data.msg, {
              title: "Error",
              size: "sm",
              buttonSize: "sm",
              okVariant: "danger",
              headerClass: "p-10 border-bottom-0",
              footerClass: "p-2 border-top-0",
              centered: true,
            });
          }
          this.apiStatus = res.data.status;
          console.log("Status is:",res.data.status);
          this.isLoading = false;
        });
    },

    search() {
      this.page = this.pageNumOnSearch;
      this.getProductionReport();
    },
    gettimeSlots() {
      axios
        .post("/timeslots/getall", { CompanyId: this.$auth.user().companyId })
        .then((res) => {
          //  console.log(res.data)
          if (res.data.status == 1) {
            this.timeSlots = res.data.data;
          } else if (res.data.status == -1) {
            this.$refs.toaster.showToast("Error", "danger", res.data.msg);
          }
        })
        .catch((err) => {
          console.warn("error during http call", err);
        });
    },
    getTimeWiseProductions() {
      console.log("Called from 1");
      this.SelectedEndTimeSlot = 24; //select last timeslot
      this.productionData = null;
      this.isLoading = true;
      this.getProductionReport();
      this.isLoading = false;
    },
    GetEndTimeWiseProductions(){
       console.log("Called from 2");
      //IF END TIME IS LESS THEN START TIME GIVE AN ERROR MSG
      if(this.SelectedEndTimeSlot < this.SelectedStartTimeSlot && this.StartDate===this.EndDate){
        // this.$refs.toaster.showToast("Error", "danger", "Please select correct end time");
        this.$bvToast.toast("Please select correct End Time", {
          title: "Error",
          solid: true,
          variant: 'danger'
        })
       return;
      }
      this.productionData = null;
      this.isLoading = true;
      this.getProductionReport();
      this.isLoading = false;
    }
  },
  created() {
    var date = new Date();
    this.StartDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      1,
      this.StartDate.getHours()
    );
    // console.log(this.StartDate)
    // this.StartDate.setFullYear(date.getFullYear(), date.getMonth(), 1)
    this.EndDate = new Date(
      date.getFullYear(),
      date.getMonth() + 1,
      0,
      this.EndDate.getHours()
    );
    // console.log(this.EndDate)
    // this.EndDate.setFullYear(date.getFullYear(), date.getMonth() + 1, 0);
    this.gettimeSlots();
    this.getProductionReport();
   
    // this.getStudents();
    //localStorage.setItem("mytime", Date.now());
  },
  components: {
    Spinner,
  },
};
</script>

<style scoped>
button.page-link {
  display: inline-block;
}
button.page-link {
  font-size: 20px;
  color: #29b3ed;
  font-weight: 500;
}
.offset {
  width: 500px !important;
  margin: 20px auto;
}
select#class-dropdown {
  width: 80%;
  margin-left: 16%;
}
.custom-row {
  overflow: visible !important;
}
.form-group {
    margin-bottom: 0.4rem;
}
.nav-tabs{
    font-size: 22px !important;
    border-bottom: none !important;
}
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    border-bottom: 2px solid transparent !important;
}

</style>
